import { css } from "lit";

/**
 * pd-button im Register — an EINER Stelle (KONZEPT-gestaltungssystem.md, 8.2;
 * Artboard „Knöpfe und Umschalter“).
 *
 * NORMALFORM IST DER TEXTKNOPF: Mono in zweiter Tinte, ohne Rahmen und Grund,
 * mit Zeichen statt Icon („↑ Frühere Sitzungen anzeigen“), Hover Petrol,
 * 44 px hoch — unsichtbar, aber ein Berührziel. Ein Knopf ist das lauteste
 * Element einer Seite; der gestrichelte Petrol-Rahmen war ein vierter
 * Akzent-Einsatz und die Display-Schrift ein Anschlag, wo keiner hingehört.
 *
 * EIN RAHMEN-KNOPF JE SEITE (`outline`): die Hauptaktion — der Filter-Knopf auf
 * Mobil, das Installieren. 1 px Tinte, Radius 2 px, Hover Fläche — nie gefüllt.
 * Kein `primary` im Portal.
 */
export const knopfStyles = css`
  pd-button {
    font-family: var(--portal-font-mono);
    --pd-button-font-size: var(--portal-size-sm);
    --pd-button-font-weight: 400;
    --pd-button-height: var(--portal-touch);
    --pd-button-min-height: var(--portal-touch);
    --pd-button-padding: 0;
    --pd-button-border-radius: var(--portal-radius);
    --pd-button-bg-col: transparent;
    --pd-button-bg-col-hover: transparent;
    --pd-button-bg-image: none;
    --pd-button-border-col: transparent;
    --pd-button-font-col: var(--portal-ink-2);
    --pd-button-font-col-hover: var(--portal-akzent);
    --pd-text-shadow-sm: none;
  }
  pd-button[outline] {
    --pd-button-padding: var(--portal-space-4);
    --pd-button-outline-border-style: solid;
    --pd-button-outline-border-col: var(--portal-ink);
    --pd-button-outline-font-col: var(--portal-ink);
    --pd-button-outline-bg-col-hover: var(--portal-flaeche);
  }
`;
